const app = {
  user: null,
  workspace: null,
  userId: null,
  authenticatedUserId: null,
  markup: {},
  modelList: [],
  pluginList: null,
  chatListOfSession: {},
  projectListOfSession: {},
};

window.app = app;

export { app };
